export enum VoiceEvent {
  incoming = "incoming"
}
